import script from "./details.vue?vue&type=script&setup=true&lang=js"
export * from "./details.vue?vue&type=script&setup=true&lang=js"

import "./details.vue?vue&type=style&index=0&id=03ea2b46&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ea2b46"]])

export default __exports__